import styled from 'styled-components';

export const UsersCreatedWrapper = styled.div`
  margin-top: 20px;
`;
